// Shared layout + typography for legal pages (Privacy, Security, Terms).
import { Link } from "react-router-dom";
import { MarketingHeader } from "@/components/marketing/MarketingHeader";
import { MarketingFooter } from "@/components/marketing/MarketingSections2";
import { HardHat } from "lucide-react";

export function LegalLayout({ children, tag, title, intro, lastUpdated }) {
  return (
    <div className="min-h-screen bg-[#f6f5f1] text-[#142635]">
      <MarketingHeader />
      <main className="max-w-3xl mx-auto px-6 md:px-12 py-12">
        <div className="label-tag !text-[#a63c0b] mb-2">{tag}</div>
        <h1 className="font-display font-black uppercase tracking-tight text-4xl sm:text-5xl mb-3" data-testid="legal-page-title">
          {title}
        </h1>
        {intro && <p className="text-[#52616c] text-lg leading-relaxed mb-2">{intro}</p>}
        {lastUpdated && (
          <p className="text-[10px] font-bold uppercase tracking-widest text-[#52616c] mt-4 mb-8 border-b border-[#cbd3d5] pb-4">
            Last updated · {lastUpdated}
          </p>
        )}
        <article className="legal-prose space-y-6">{children}</article>
        <div className="mt-16 pt-8 border-t border-[#cbd3d5] text-xs text-[#52616c] flex flex-wrap justify-between gap-2">
          <div>© 2026 Fieldlink Aotearoa Ltd · 100% NZ owned</div>
          <div>
            <a href="mailto:privacy@fieldlink.co.nz" className="hover:text-[#a63c0b]">privacy@fieldlink.co.nz</a>
          </div>
        </div>
      </main>
      <MarketingFooter />
    </div>
  );
}

export function Section({ id, title, children }) {
  return (
    <section id={id} className="scroll-mt-24" data-testid={id ? `legal-section-${id}` : undefined}>
      <h2 className="font-display font-extrabold uppercase tracking-tight text-xl mt-8 mb-3">{title}</h2>
      <div className="space-y-3 text-sm leading-relaxed text-[#465562]">{children}</div>
    </section>
  );
}

export function Highlight({ children, tone = "orange" }) {
  const cls = tone === "orange"
    ? "rounded-r-md border-l-4 border-[#FF5F15] bg-[#FF5F15]/10"
    : "border-l-4 border-emerald-500 bg-emerald-500/10";
  return <div className={`${cls} p-4 my-4 text-sm`}>{children}</div>;
}
